import { Heading } from '@core/ui';

import { HeadingProps } from '../ProfileHeading/types';

export const ChangePasswordFormTitle = ({ title, classNames }: HeadingProps) => (
    <Heading variant="h2" classNames="md:pb-10">
        {title}
    </Heading>
);
